import React, { useState, useEffect } from "react";
import { Button, Col, Dropdown, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { CgUndo } from "react-icons/cg";
import { toast } from "react-toastify";
import _ from "lodash";
// import HtmlToString from "../../../../components/Formatters/HtmlToString";
import DateTime from "../../../../components/Formatters/DateTime";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";
import useCancelarAndamento from "../hooks/useCancelarAndamento";
import FormAlert from "../../../../components/UI/FormAlert/FormAlert";
import FileDownloader from "../../../../components/UI/Button/FileDownloader";
import TelaProximaAtividadeAIEspecial from "./TelaProximaAtividadeAIEspecial";
import AndamentoAutoInfracaoEsp from "./AndamentoAutoInfracaoEsp";

const AutoInfracaoEspecialDetalhe = ({ row }) => {
  const [mostrarAndamento, setAndamentoShow] = useState(false);
  const SolicitarMostrarAndamento = () => {
    if (!mostrarAndamento) {
      setAndamentoShow(true);
    } else {
      setAndamentoShow(false);
    }
  };

  const { data } = row;

  const [proximasAtividades, setProximasAtividades] = useState([]);
  const {
    request: proximasAtividadesRequest,
    data: proximasAtividadesData,
    errors: proximasAtividadesErrors,
  } = useApiClient();

  useEffect(() => {
    if (
      data.sequencialRoteiro &&
      data.sequencialRoteiro > 0 &&
      data.sequencialUltimaAtividade &&
      data.sequencialUltimaAtividade > 0
    ) {
      const parametros = {
        sequencialRoteiro: data.sequencialRoteiro,
        sequencialAtividade: data.sequencialUltimaAtividade,
        sequencialAcaoFiscal: data.dadosOs.acaoFiscal,
      };

      proximasAtividadesRequest(apiRoutes.fiscalizacao.ordemservico.proximasAtividades, parametros);
    }
  }, [proximasAtividadesRequest, data]);

  useEffect(() => {
    if (!proximasAtividadesData && !proximasAtividadesErrors) return;

    if (proximasAtividadesData) {
      setProximasAtividades(proximasAtividadesData.result);
    }

    if (proximasAtividadesErrors) toast.error(proximasAtividadesErrors.message);
  }, [proximasAtividadesData, proximasAtividadesErrors]);

  const [proximaAtividadeSelecionada, setProximaAtividadeSelecionada] = useState({});
  const handleRealizarAtividade = (_atividade) => {
    setProximaAtividadeSelecionada(_atividade);
  };

  const { cancelarAndamento, cancelarErrors, cancelarIsLoading } = useCancelarAndamento({ data });

  return (
    <>
      <FormAlert formik={data} data={data} errors={cancelarErrors} isLoading={cancelarIsLoading} dismissible />
      {/* <Row style={{ margin: 20, textAlign: "left" }}>
        <Col xs={12}>
          <strong>Justificativa: </strong>
          <br />
          <span>
            {" "}
            <HtmlToString html={data?.justificativa} />
          </span>
        </Col>
      </Row> */}
      <Row sm="12">
        <Col>
          <Row className="mt-4" style={{ margin: 20, textAlign: "left" }}>
            <Col>
              <p>
                <strong>Última Atividade Realizada</strong>
                <br />
                {data?.nomeUltimaAtividade === null ? (
                  "-"
                ) : (
                  <>
                    <span className="text-primary"> {data.nomeUltimaAtividade} </span>
                    {data.docUltimaAtividade !== null && (
                      <FileDownloader
                        binario={data.docUltimaAtividade}
                        tooltip="Visualizar Documento"
                        className="ml-2"
                      />
                    )}

                    <OverlayTrigger placement="top" overlay={<Tooltip>Cancelar</Tooltip>}>
                      <CgUndo
                        className="text-danger pa-0 p-0 btn btn-lg btn-bg-transparent"
                        onClick={() => cancelarAndamento()}
                      />
                    </OverlayTrigger>
                  </>
                )}
                <br />( {data.codigoUserUltimaAtividade} - {data.nomeUserUltimaAtividade} -
                <DateTime value={data.dataInclusaoUltimaAtividade} /> )
              </p>
              {data?.situacaoUltimoAndamento !== "A" && (
                <Dropdown className="mt-4 mb-4">
                  <Dropdown.Toggle variant="outline-secondary" id="dropdown-basic">
                    Realizar Atividade
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {proximasAtividades?.length > 0 ? (
                      proximasAtividades.map((_atividade) => {
                        const itemMenu = (
                          <Dropdown.Item onClick={() => handleRealizarAtividade(_atividade)}>
                            {_atividade.nomeAtividade}
                          </Dropdown.Item>
                        );
                        return itemMenu;
                      })
                    ) : (
                      <span className="m-0 font-weight-bold text-primary flex-grow-1 px-2">
                        Nenhuma atividade para o usuário logado
                      </span>
                    )}
                  </Dropdown.Menu>
                </Dropdown>
              )}

              <TelaProximaAtividadeAIEspecial
                dadosOs={data.dadosOs}
                data={data}
                atividade={
                  proximaAtividadeSelecionada.sequencialAtividade
                    ? proximaAtividadeSelecionada
                    : _.find(
                        proximasAtividades, // -> Sequencial da atividade do ultimo andamento
                        (atividade) => atividade.sequencialAtividade === data?.sequencialAtividadeAndamento,
                      )
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>

      <Row style={{ marginLeft: -5, marginTop: 0, marginBottom: 20, textAlign: "left" }}>
        <Col sm="12" className="form-inline">
          <Button className="mr-0 btn btn-primary btn-sm btn-user mx-4" onClick={() => SolicitarMostrarAndamento()}>
            Andamento Auto Infração Especial
          </Button>
        </Col>
      </Row>
      <Row hidden={!mostrarAndamento} style={{ marginLeft: -15, marginTop: 0, marginBottom: 20 }}>
        <Col>
          <div>
            <Col sm="12" className="form-inline justify-content-end">
              <AndamentoAutoInfracaoEsp dadosAiEspecial={data} />
            </Col>
          </div>
        </Col>
      </Row>
    </>
  );
};
export default AutoInfracaoEspecialDetalhe;
